import React, { useEffect, useRef, useState } from "react";
import { PageFlip } from "page-flip";
import image1 from "../assets/catlog/CATALOUG (2)_page-0001.jpg";
import image2 from "../assets/catlog/CATALOUG (2)_page-0002.jpg";
import image3 from "../assets/catlog/CATALOUG (2)_page-0003.jpg";
import image4 from "../assets/catlog/CATALOUG (2)_page-0004.jpg";
import image5 from "../assets/catlog/CATALOUG (2)_page-0005.jpg";
import image6 from "../assets/catlog/CATALOUG (2)_page-0006.jpg";
import image7 from "../assets/catlog/CATALOUG (2)_page-0007.jpg";
import image8 from "../assets/catlog/CATALOUG (2)_page-0008.jpg";
import image9 from "../assets/catlog/CATALOUG (2)_page-0009.jpg";
import image10 from "../assets/catlog/CATALOUG (2)_page-0010.jpg";

export default function Flipbook() {
  const pages = [
    {
      image: image1,
    },
    {
      image: image2,
    },
    {
      image: image3,
    },
    {
      image: image4,
    },
    {
      image: image5,
    },
    {
      image: image6,
    },
    {
      image: image7,
    },
    {
      image: image8,
    },
    {
      image: image9,
    },
    {
      image: image10,
    },
  ];
  const bookRef = useRef(null);
  const pageFlipRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // Book pages content

  useEffect(() => {
    if (bookRef.current && !pageFlipRef.current) {
      pageFlipRef.current = new PageFlip(bookRef.current, {
        width: 600,
        height: 850,
        size: "stretch",
        minWidth: 315,
        maxWidth: 1000,
        minHeight: 400, 
        maxHeight: 1350,
        maxShadowOpacity: 0.5,
        showCover: true,
        mobileScrollSupport: false,
      });

      pageFlipRef.current.loadFromHTML(document.querySelectorAll(".page"));

      setTotalPages(pageFlipRef.current.getPageCount());

      pageFlipRef.current.on("flip", (e) => {
        setCurrentPage(e.data);
      });
    }
  }, []);

  // const nextPage = () => {
  //   if (pageFlipRef.current) {
  //     pageFlipRef.current.flipNext();
  //   }
  // };

  // const prevPage = () => {
  //   if (pageFlipRef.current) {
  //     pageFlipRef.current.flipPrev();
  //   }
  // };

  const goToPage = (pageNum) => {
    if (pageFlipRef.current) {
      pageFlipRef.current.flip(pageNum);
    }
  };

  return (
    <div className="min-h-screen bg-[#B5B5B5] mt-8 from-slate-900 via-purple-900 to-slate-900 flex flex-col items-center justify-center p-4">
      {/* Book Container */}
      <div className="relative mb-8">
        <div ref={bookRef} className="flipbook shadow-2xl">
          {/* Cover Page */}

          {/* Content Pages */}
          {pages.map((page, index) => (
            <div
              key={index}
              className={`page ${page.bgColor} text-white relative overflow-hidden`}
            >
              <img
                src={page.image}
                alt={page.title}
                className="absolute inset-0 w-full h-full object-cover "
              />
            </div>
          ))}
        </div>
      </div>

      {/* Page Navigation Dots */}
      <div className="flex gap-2 flex-wrap justify-center max-w-md">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            onClick={() => goToPage(i)}
            className={`w-3 h-3 rounded-full transition-all ${
              i === currentPage
                ? "bg-white w-8"
                : "bg-white bg-opacity-40 hover:bg-opacity-70"
            }`}
            title={`Go to page ${i}`}
          />
        ))}
      </div>

      <style jsx>{`
        .flipbook {
          margin: 0 auto;
        }

        .page {
          background-size: cover;
          background-position: center;
        }

        .page::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.1) 0%,
            transparent 10%,
            transparent 90%,
            rgba(0, 0, 0, 0.1) 100%
          );
          pointer-events: none;
        }
      `}</style>
    </div>
  );
}
